import gql from "graphql-tag";

// eslint-disable-next-line import/no-default-export
export default gql`
	mutation save($input: SaveCommentInput!) {
		saveComment(input: $input) {
			boolean
		}
	}
`;
